export type ValidationErrorDataType = {
  id: string;
  modalTitle?: string;
  errorDescription?: string;
  tokenValues?: Record<string, string>;
  bodyDescription?: string;
};

/**
 * Error object returned from Validator API does not contain
 * the translation required to show in the UI (modal title, error description, body description).
 * This object maps the error id to the translation keys.
 */
export const validationErrorsMessages: Record<string, ValidationErrorDataType> = {
  CorruptValidator: {
    id: 'CorruptValidator',
    modalTitle: 'validations.corrupt file.error-modal-title',
    errorDescription: 'validations.corrupt file.error-description',
    bodyDescription: 'validations.corrupt file.error-body-description',
  },
  PageSizeValidator: {
    id: 'PageSizeValidator',
    modalTitle: 'validations.page size.error-modal-title',
    errorDescription: 'validations.page size.error-description',
    bodyDescription: 'validations.page size.error-body-description',
  },
  PageCountValidator: {
    id: 'PageCountValidator',
    modalTitle: 'validations.page count.error-modal-title',
    errorDescription: 'validations.page count.error-description',
    bodyDescription: 'validations.page count.error-body-description',
  },
  PageOrientationValidator: {
    id: 'PageOrientationValidator',
    modalTitle: 'validations.page orientation.error-modal-title',
    errorDescription: 'validations.page orientation.error-description',
    bodyDescription: 'validations.page orientation.error-body-description',
  },
  UnEmbeddedFontsValidator: {
    id: 'UnEmbeddedFontsValidator',
    modalTitle: 'validations.UnEmbeddedFontsValidator.error-modal-title',
    errorDescription: 'validations.UnEmbeddedFontsValidator.error-description',
    bodyDescription: 'validations.UnEmbeddedFontsValidator.error-body-description',
  },
  ImageResolutionValidator: {
    id: 'image resolution',
    modalTitle: 'validations.image resolution.error-modal-title',
    errorDescription: 'validations.image resolution.error-description',
    bodyDescription: 'validations.image resolution.error-body-description',
  },
  EncryptedValidator: {
    id: 'encrypted file',
    modalTitle: 'validations.encrypted file.error-modal-title',
    errorDescription: 'validations.encrypted file.error-description',
    bodyDescription: 'validations.encrypted file.error-body-description',
  },
};
